import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../styles/componentStyles/WaterIntake.css';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import waterDrop0 from '../../assets/icons/water-drop-blue-0.png';
import waterDrop1 from '../../assets/icons/water-drop-blue-1.png';
import waterDrop10 from '../../assets/icons/water-drop-blue-10.png';
import waterDrop11 from '../../assets/icons/water-drop-blue-11.png';
import waterDrop2 from '../../assets/icons/water-drop-blue-2.png';
import waterDrop3 from '../../assets/icons/water-drop-blue-3.png';
import waterDrop4 from '../../assets/icons/water-drop-blue-4.png';
import waterDrop5 from '../../assets/icons/water-drop-blue-5.png';
import waterDrop6 from '../../assets/icons/water-drop-blue-6.png';
import waterDrop7 from '../../assets/icons/water-drop-blue-7.png';
import waterDrop8 from '../../assets/icons/water-drop-blue-8.png';
import waterDrop9 from '../../assets/icons/water-drop-blue-9.png';

const waterDropImages = [
  waterDrop0,
  waterDrop1,
  waterDrop2,
  waterDrop3,
  waterDrop4,
  waterDrop5,
  waterDrop6,
  waterDrop7,
  waterDrop8,
  waterDrop9,
  waterDrop10,
  waterDrop11,
];

function WaterIntake(props) {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (props.data?.[props.questionid]) {
      setValue(props.data[props.questionid]);
    }
  }, [props.data, props.questionid]);

  const increaseValue = () => {
    let newValue = value;
    if (newValue < 11) {
      newValue++;
      setValue(newValue);
      props.saveResponse('data', {
        id: props.questionid,
        value: newValue,
      });
    }
  };

  const decreaseValue = () => {
    let newValue = value;
    if (newValue > 0) {
      newValue--;
      setValue(newValue);
      props.saveResponse('data', {
        id: props.questionid,
        value: newValue,
      });
    }
  };

  const handleInputChange = (event) => {
    const newValue = Number(event.target.value);
    if (!Number.isNaN(newValue) && newValue >= 0 && newValue <= 11) {
      setValue(newValue);
      props.saveResponse('data', {
        id: props.questionid,
        value: newValue,
      });
    }
  };

  return (
    <div>
      <div className="tracker-cont">
        <div className="water-input-wrapper">
          <div className="water-input">
            <img
              className="water-drop fs-exclude"
              src={waterDropImages[value || 0]}
              alt="water drop fill indicator"
              aria-hidden="true"
            />
            <input
              type="number"
              className="water-value fs-exclude"
              id={`${props.questionid}-input`}
              name="water-intake"
              value={value || 0}
              onChange={handleInputChange}
              max={11}
              min={0}
              step={1}
              aria-label={t('T164WA')}
            />
            <div className="water-controls">
              <button
                className="up-btn"
                onClick={increaseValue}
                aria-label={`${t('A134')} ${t('T164WA')}`}
                type="button"
              >
                <FontAwesomeIcon icon={faChevronUp} className="icon" aria-hidden="true" />
              </button>
              <button
                className="down-btn"
                onClick={decreaseValue}
                aria-label={`${t('A135')} ${t('T164WA')}`}
                type="button"
              >
                <FontAwesomeIcon icon={faChevronDown} className="icon" aria-hidden="true" />
              </button>
            </div>
          </div>
          <div className="water-suffix">
            {t('T164WA')}{' '}
            <span className="water-suffix-subtext">
              ({value * 0.25}
              {t('T164WC')} {t('T164WB')})
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WaterIntake;
